import { render, staticRenderFns } from "./RegistrationTerminal.vue?vue&type=template&id=ef500896"
import script from "./RegistrationTerminal.vue?vue&type=script&lang=js"
export * from "./RegistrationTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports